<template lang="pug">
  fieldset(:disabled="disabled || loading")
    form(@submit.prevent="submitForm", :autocomplete="autocomplete")
      div.alert.alert-success(v-if="success_message", v-text="success_message")
      div.alert.alert-danger(v-if="error_message", v-text="error_message")
      slot
</template>

<script>
import {has,get} from 'lodash-es'

export default {
  name: 'AppForm',
  props: {
    endpoint: String,
    method: {
      type: String,
      default: 'POST'
    },
    disabled: Boolean,
    autocomplete: {
      type: String,
      default: 'on'
    },
    data: [Object, FormData]
  },
  provide() {
    return {
      appForm: this
    }
  },
  data: () => ({
    loading: false,
    error_message: '',
    success_message: ''
  }),
  computed: {
  },
  mounted() {
    if ( get(this, '$parent.$parent.$options.name') === 'VueJsModal' ) {
        this.$parent.$parent.$emit('register:form', this)
    }

    this.$on('submit', () => this.submitForm())
  },
  methods: {
    setLoading(state) {
      setTimeout(function() {
      }.bind(this), state ? 1 : 1000)
    },
    submitForm() {
      var vm = this
      this.setLoading(true)
      this.error_message = ''
      this.success_message = ''
      this.$emit('errors', {})
      this.$emit('loading', true)

      this.$http({
        method: this.method,
        url: this.endpoint,
        data: this.data
      })
      .then(response => {
        this.success_message = get(response, 'data.message', false)
        this.$emit('success', response)
      })
      .catch(error => {
        this.$emit('error', error)
        if ( get(error, 'response.status') === 422 ) {
          this.error_message = 'Please correct the fields highlighted in red below'
          this.$emit('errors', get(error, 'response.data.errors', {}))
        } else {
          this.error_message = get(error, 'response.data.error', get(error, 'response.data.message', error.message))
        }
      })
      .finally(() => this.$emit('finished', true))
    }
  }
}
</script>
